import { render, staticRenderFns } from "./SendNoLongerInterestedAction.vue?vue&type=template&id=2d218338"
import script from "./SendNoLongerInterestedAction.vue?vue&type=script&lang=js"
export * from "./SendNoLongerInterestedAction.vue?vue&type=script&lang=js"
import style0 from "./SendNoLongerInterestedAction.vue?vue&type=style&index=0&id=2d218338&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports